import { Component, Input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss'
})
export class PageHeaderComponent {
  @Input() breadcrumb = '';
  @Input() title = '';
  @Input() keepIconOnMobile = false;
  // Admin pages use the two-chevron brand arrows (styles/sgl-arrows.scss) instead of the
  // three-chevron header image the rest of the app still carries.
  @Input() doubleArrows = false;
}
